<template>

    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <b-button
              variant="success"
              @click="getEvents"
          >
            ACTUALIZAR EVENTOS <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
          </b-button>
        </div>
        <div class="col-12">
          <FullCalendar :options="calendarOptions" />
        </div>
      </div>
      <b-modal id="modal-1" title="RESERVAR SALA ZOOM" ref="my-modal-new-event" hide-footer
               no-close-on-esc no-close-on-backdrop hide-header-close>
        <div class="row">
          <div class="col-6">
            <label for="timepicker-sm">Hora Inicio</label>
            <b-form-timepicker disabled id="timepicker-inicio" size="sm" locale="es" class="mb-2" :hour12="false" v-model="dataNewEvent.hini"></b-form-timepicker>
          </div>
          <div class="col-6">
            <label for="timepicker-sm">Hora Cierre</label>
            <b-form-timepicker id="timepicker-fin" size="sm" locale="es" class="mb-2" :hour12="false" v-model="dataNewEvent.hfin"></b-form-timepicker>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="input-2"><code>Usuario</code>:</label>
            <b-form-input
                id="input-2"
                v-model="dataNewEvent.creador"
                placeholder="Ingresa tú nombre"
                required
            ></b-form-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="textarea"><code>Motivo</code>:</label>
            <b-form-textarea
                id="textarea"
                v-model="dataNewEvent.motivo"
                placeholder="Describe el uso de la sala..."
                rows="3"
                max-rows="6"
            ></b-form-textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="input-3"><code>Color Evento</code>:</label>
            <b-form-input
                id="input-3"
                v-model="dataNewEvent.color"
                placeholder="Selecciona el color"
                required
                type="color"
            ></b-form-input>
          </div>
        </div>
        <br>
        <div class="row border-top">
          <div class="col-4 border-top"></div>
          <div class="col-4 border-top">
            <br>
            <b-button
                variant="danger"
                size="sm"
                @click="cancelModal"
            >
              CANCELAR EVENTO
            </b-button>
          </div>
          <div class="col-4 ">
            <br>
            <div class="float-right">
              <b-button
                  variant="success"
                  size="sm"
                  @click="hideModal"
              >
                REGISTRAR EVENTO
              </b-button>
            </div>
          </div>
        </div>

      </b-modal>
  </div>
</template>

<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es';
import timeGridPlugin from '@fullcalendar/timegrid';
export default {
  name: "Calendar",
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  data() { let $this = this;
    return {
      dataNewEvent:{
        motivo:'',
        color:'#ff9200',
        creador:'',
        hini:'',
        hfin:'',
        fecha:'',
        uuid :''
      },
      calendarOptions: {
        locales: [ esLocale ],
        plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
        //initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
          locale: 'es',
        },
        contentHeight:600,
        slotMinTime:'06:00:00',
        initialView: 'timeGridWeek',
        weekNumbers: true,
        eventClick: function(info) {

          let timeI = String(info.event.start).replace("T", "-");
          let timeE = String(info.event.end).replace("T", "-");
          timeI = timeI.split(' ');
          timeE = timeE.split(' ');
          if (info.view.type === 'timeGridWeek'){
            $this.$swal.fire({
              title:'',
              html:timeI[3] + '-' + timeI[1] + '-' + timeI[2] + '<br>' + timeI[4] + ' - ' + timeE[4] + '<br><b>' + info.event.title +'</b>',
              showCancelButton: true,
              confirmButtonText: 'Cerrar',
              cancelButtonText: 'Eliminar Evento',
              cancelButtonColor:'#e30d0d'
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (!result.isConfirmed) {

                $this.$swal.fire({
                  title: 'Ingrese Contraseña',
                  input: 'password',
                  inputLabel: 'Para eliminar evento',
                  inputPlaceholder: 'Ingrese contraseña'
                }).then((result) => {
                  $this.axios.post('https://grupopromociones.com/back/peticiones/deleteEvents.php', {
                        fecha: timeI[3] + '-' + timeI[1] + '-' + timeI[2], horaInicial: timeI[4], evento: info.event.id,password:result.value
                      })
                      .then(function (r) {
                        // handle success
                        console.log(r);
                        if (r.data.Success) {
                          $this.$toastMessage('success', r.data.Mensaje, 6000, 'top-right');
                          $this.getEvents();
                        } else {
                          $this.$toastMessage('error', r.data.Mensaje, 6000, 'center');
                        }
                      })
                      .catch(function (error) {
                        // handle error
                        console.log(error);
                      });
                });



              }
            })
          }
        },
        selectable: true,
        dateClick: function(info) {
          //alert('Clicked on: ' + info.dateStr);
          //alert('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
          //alert('Current view: ' + info.view.type);
          // change the day's background color just for fun
          //info.dayEl.style.backgroundColor = 'red';
          if (info.view.type === 'timeGridWeek'){
            $this.showModal(info.dateStr);
          }
        },
        events: []
      }
    }
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    showModal(time) {
      time = time.replace("T", "-");
      time = time.split('-');
      let time2;
      time2 = time[3].split(':');
      time2 = (parseInt(time2[0]) + 1);
      time2 = String(time2);
      time2 = time2.padStart(2, "00");
      this.dataNewEvent.hini = time[3];
      this.dataNewEvent.hfin = time2 + ':59:59';
      this.dataNewEvent.uuid = this.createUUID();
      this.dataNewEvent.fecha = time[0] + '-' + time[1] + '-' + time[2];
      if (this.ValidarFechas(this.dataNewEvent.fecha)){
        this.savePre(this.dataNewEvent.fecha, this.dataNewEvent.hini, this.dataNewEvent.hfin, this.dataNewEvent.uuid);
      }
      else{
        this.$toastMessage('error', "No podemos agregar eventos, en fechas pasadas", 4000, 'top-right');
      }

    },
    hideModal() {
      this.saveEvent();
    },
    cancelModal() {
      let $this = this;
      this.axios.post('https://grupopromociones.com/back/peticiones/cancelEvent.php', {
        data: this.dataNewEvent
      }, {
        withCredentials: false,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
      })
          .then(function (r) {
            // handle success
            console.log(r);
            if (r.data.Success) {
              $this.$toastMessage('success', r.data.Mensaje, 6000, 'top-right');
              $this.getEvents();
              $this.$refs['my-modal-new-event'].hide();
            }
          })
          .catch(function (error) {
            // handle error
            $this.$toastMessage('success', error, 6000, 'top-right');
          });

    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal-new-event'].toggle('#toggle-btn')
    },
    getEvents() {
      let $this = this;
      this.calendarOptions.events = [];
      this.axios.post('https://grupopromociones.com/back/peticiones/getEvents.php', {}, {
        withCredentials: false,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
      })
          .then(function (r) {
            // handle success
            console.log(r);
            if (r.data.Success) {
              //$this.$toastMessage('success',r.data.Mensaje,6000,'top-right');
              $this.calendarOptions.events = r.data.Events;
            }
          })
          .catch(function (error) {
            // handle error
            $this.$toastMessage('success', error, 6000, 'top-right');
          });
    },
    savePre(fecha, hi, hf, name) {
      let $this = this;
      this.axios.post('https://grupopromociones.com/back/peticiones/savePreRegister.php', {
        fecha: fecha, name: name, fini: hi, ffin: hf
      }, {
        withCredentials: false,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
      })
          .then(function (r) {
            // handle success
            console.log(r);
            if (r.data.Success) {
              $this.$toastMessage('success', r.data.Mensaje, 6000, 'top-right');
              $this.$refs['my-modal-new-event'].show();
            } else {
              $this.getEvents();
              $this.$toastMessage('error', r.data.Mensaje, 6000, 'center');
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
    },
    saveEvent() {
      let $this = this;
      if (this.dataNewEvent.creador === '') {
        this.$toastMessage('error', "Ingrese su nombre por favar!", 6000, 'center');
      } else if (this.dataNewEvent.creador.length < 6) {
        this.$toastMessage('error', "Ingrese el nombre con más de 6 caracteres", 6000, 'center');
      } else if (this.dataNewEvent.motivo.length === 0) {
        this.$toastMessage('error', "Ingrese el motivo para continuar", 6000, 'center');
      } else if (this.dataNewEvent.motivo.length < 10) {
        this.$toastMessage('error', "Ingrese el motivo con más de 10 caracteres", 6000, 'center');
      } else {
        this.axios.post('https://grupopromociones.com/back/peticiones/saveRegister.php', {
          data: this.dataNewEvent
        }, {
          withCredentials: false,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
          }
        })
            .then(function (r) {
              // handle success
              console.log(r);
              if (r.data.Success) {
                $this.$toastMessage('success', r.data.Mensaje, 6000, 'top-right');
                $this.$refs['my-modal-new-event'].hide();
                $this.getEvents();
              }
            })
            .catch(function (error) {
              // handle error
              $this.$toastMessage('error', error, 6000, 'center');
            });
      }

    },
    createUUID() {
      // http://www.ietf.org/rfc/rfc4122.txt
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    ValidarFechas(fcompare) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today =  yyyy + '-' + mm + '-' + dd;
      return Date.parse(fcompare) >= Date.parse(today);
    }
  }
}
</script>

<style scoped>

</style>